import React from 'react';
import { FUNDING_SUBMISSION_METHODS } from '../../utils/funding/constants';

const FundingSubmissionForm = ({ values, onChange, onSubmit, saving, error }) => (
  <form className="space-y-4" onSubmit={(event) => { event.preventDefault(); onSubmit(); }}>
    {error ? (
      <div className="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-200">
        {error}
      </div>
    ) : null}
    <div className="grid gap-3 sm:grid-cols-2">
      <label className="block text-sm sm:col-span-2">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Lender name</span>
        <input value={values.lender_name} onChange={(e) => onChange({ ...values, lender_name: e.target.value })} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm" required />
      </label>
      <label className="block text-sm">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Lender type</span>
        <input value={values.lender_type} onChange={(e) => onChange({ ...values, lender_type: e.target.value })} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm" />
      </label>
      <label className="block text-sm">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Product type</span>
        <input value={values.product_type} onChange={(e) => onChange({ ...values, product_type: e.target.value })} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm" required />
      </label>
      <label className="block text-sm">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Requested amount</span>
        <input type="number" value={values.requested_amount} onChange={(e) => onChange({ ...values, requested_amount: e.target.value })} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm" />
      </label>
      <label className="block text-sm">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Submission method</span>
        <select value={values.submission_method} onChange={(e) => onChange({ ...values, submission_method: e.target.value })} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm">
          {FUNDING_SUBMISSION_METHODS.map((method) => <option key={method} value={method}>{method}</option>)}
        </select>
      </label>
      <label className="block text-sm sm:col-span-2">
        <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Notes</span>
        <textarea value={values.notes} onChange={(e) => onChange({ ...values, notes: e.target.value })} rows={3} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm" />
      </label>
    </div>
    <button type="submit" disabled={saving} className="rounded-xl bg-[var(--fg-accent)] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#126b4f] disabled:opacity-60">
      {saving ? 'Saving...' : 'Create Submission'}
    </button>
  </form>
);

export default FundingSubmissionForm;
